module.exports = __webpack_public_path__ + "files/1852d8b8f7be362850d9d95d0d0bdae3.png";